define('TescoMobile_CheckoutCareHub/js/view/message-modal-insurance',['uiComponent', 'jquery', 'Magento_Ui/js/modal/modal', 'Magento_Customer/js/customer-data', 'Magento_Catalog/js/price-utils', 'TescoMobile_Checkout/js/model/insurance', 'TescoMobile_Checkout/js/action/get-insurances', 'mage/translate', 'underscore'], function (Component, $, modal, customerData, priceUtils, insuranceModel, getInsuranceAction, $t, _) {
  'use strict';

  return Component.extend({
    defaults: {
      cmsBlock: null,
      updatedCmsBlock: null,
      insuranceCost: null,
      selectedInsurance: null,
      isContinueChecked: false,
      continueClass: 'disabled'
    },
    isLoading: true,
    initialize: function () {
      $('body').on('change', '#dsr_id_checkbox', function () {
        if (this.checked) {
          $('.carehub-copy-continue').prop("disabled", false).removeClass('disabled');
        } else {
          $('.carehub-copy-continue').prop("disabled", true).addClass('disabled');
        }
      });
      $('body').on('click', '.print-pdf', function () {
        document.getElementById("print-pdf-frame").contentWindow.print();
      });
      this._super();
    },
    initObservable: function () {
      this._super().observe(['isLoading', 'updatedCmsBlock', 'selectedInsurance', 'isContinueChecked', 'continueClass']);
      return this;
    },
    updateButtonClass: function (newValue) {
      return newValue ? this.continueClass('') : this.continueClass('disabled');
    },
    setModalElement: function (element) {
      var options = {
        type: 'slide',
        innerScroll: true,
        clickableOverlay: false,
        modalClass: 'carehub-cms-block-modal insurance'
      };
      modal(options, $(element));
      this.isContinueChecked.subscribe(function (newValue) {
        this.updateButtonClass(newValue);
      }.bind(this));
      $(document).on('insurance-care-hub-content-close', function (event) {
        $(element).modal('closeModal');
      }.bind(this));
      $(document).on('insurance-proceed-additional-action', function (event, sku) {
        this._updateContent(sku);
        $(element).modal('openModal');
      }.bind(this));
    },
    _updateContent: function (sku) {
      var deferred = $.Deferred();
      this.isLoading(true);
      getInsuranceAction(insuranceModel.quoteMask, insuranceModel.quoteItemId, deferred);
      $.when(deferred).done(function (insurances) {
        var selected = this.getSelected(insurances, sku),
          updatedCmsBlock = this.cmsBlock.replace('[[insurance_total]]', this.formatPrice(selected.premium)).replace('[[insurance_name]]', selected.description).replace('[[insurance_excess_total]]', this.formatPrice(selected.excess_damage)).replace('[[insurance_excess_full]]', this.formatPrice(selected.excess_full));
        var htmlObject = $(updatedCmsBlock);
        var removeSelector = '#non-' + selected.type + '-damage-point';
        htmlObject.find('.insurance-points').children(removeSelector + '-fee').remove();
        htmlObject.find('.insurance-points').children(removeSelector).remove();
        var checkboxContent = htmlObject.find('.maincontent').children('#insurance_checkbox_instore_label');
        if (checkboxContent.length > 0) {
          $('[for="continue-carehub-insurance"]').html(checkboxContent.html());
          checkboxContent.remove();
        }
        updatedCmsBlock = htmlObject.html();
        this.updatedCmsBlock(updatedCmsBlock);
      }.bind(this));
    },
    getSelected: function (insurances, sku) {
      const selected = insurances.find(function (insurance) {
        return insurance.sku == sku;
      });
      if (typeof selected !== 'undefined') {
        return selected;
      }
      return false;
    },
    saveInsurance: function () {
      $(document).trigger('insurance-care-hub-content-close');
      $(document).trigger('insurance-proceed-save');
    },
    backToSelection: function () {
      $(document).trigger('insurance-care-hub-content-close');
    },
    formatPrice: function (price) {
      return priceUtils.formatPrice(price, this.priceFormat);
    }
  });
});

